import React from 'react';
import PropTypes from 'prop-types';

import SecondaryNavDesktop from './SecondaryNavDesktop';
import SecondaryNavMobile from './SecondaryNavMobile';

const SecondaryNav = ({ links }) => {
  return (
    <>
      <SecondaryNavDesktop links={links} />
      <SecondaryNavMobile links={links} />
    </>
  );
};

SecondaryNav.propTypes = {
  links: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default SecondaryNav;
